/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: perfildocentechartController
* # alias: chartDocente
*/

export default class perfildocentechartController {

    constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.$stateParams = $stateParams;
        this.perfilSrv = perfilSrv;
        this.userinfo = null;
        this.$scope.chartConfig = {};
        this.$cookies = $cookies;
        this.$scope.UserInfoConstant = UserInfoConstant;
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.getperfildocenteChart(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.getperfildocenteChart(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    getperfildocenteChart(teacherId) {
        this.perfilSrv.perfildocente.getperfildocenteChart({teacherId:teacherId}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                Highcharts.chart('perfil_chart', {
                    chart: {type: 'column'},
                    title: {
                        style: {
                            fontWeight: 'bold'
                        },
                        align: 'center',
                        text: 'Asignaturas Dictadas por Nivel'},//'Última actualización el ' + response.data.lastUpdate},
                    xAxis: {
                        categories: response.data.category,
                        labels: {x: -10 } },
                    yAxis: {
                        tickInterval: 1,
                        minRange: 1,
                        allowDecimals: false,
                        title: {text: ""} },
                    series: response.data.series,
                    plotOptions: {column: {stacking: 'normal'}},
                    size: {height: "300", },
                    tooltip: {
                        formatter: function () {
                            return '<b>' + this.x + '</b><br/>' +
                            this.series.name + ': ' + this.y + 
                            'Total: ' + this.point.stackTotal;
                        }
                    },
                    credits: {
                        enabled: false
                    }
                });
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

}

perfildocentechartController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_docente/perfildocentechartController.js